module.exports = __webpack_public_path__ + "img/ヤクテル樹海.6b438b1c.png";